module.exports = __webpack_public_path__ + "static/media/daily-mail-black.d7630f75.png";